export function getClientIdFromModuleName(name?: string | null) {
  return name ? name + "_gateway" : undefined;
}